/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Text, Button, Group, useMantineTheme } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

import { TextVariants } from '@fai/ui/components/typography/variants';
import MessageBox from '@fai/ui/views/common/message-box';
import { MessageBoxVariant } from '@fai/ui/views/common/message-box/variants';

function ErrorMessageBox() {
  const { t } = useTranslation();

  return (
    <MessageBox variant={MessageBoxVariant.Danger}>
      <Text variant={TextVariants.BodyMd} span={true}>
        {t('team_settings.we_are_unable_to_authenticate')}
      </Text>
    </MessageBox>
  );
}

function SetupIntentFormButtons({
  disabled,
  isLoading,
}: {
  disabled: boolean;
  isLoading: boolean;
}) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Group gap={theme.pf.layout.xs}>
      <Button variant="transparent" onClick={() => modals.closeAll()}>
        {t('team_settings.cancel')}
      </Button>

      <Button theme="cloud" type="submit" disabled={disabled || isLoading} loading={isLoading}>
        {t('team_settings.save')}
      </Button>
    </Group>
  );
}

export { ErrorMessageBox, SetupIntentFormButtons };
